// extracted by mini-css-extract-plugin
export default {"Loading":"preloader_Loading__Y9QOR","circle":"preloader_circle__PskPZ","spinner-border":"preloader_spinner-border__5OR4h","spin":"preloader_spin__I2xh3"};